import { render, staticRenderFns } from "./AccordionContainer.vue?vue&type=template&id=703d60cc&"
import script from "./AccordionContainer.vue?vue&type=script&lang=ts&"
export * from "./AccordionContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports